import { APIRequest } from './api-request';

class SubscriptionService extends APIRequest {
  search(query?: { [key: string]: any }) {
    return this.get(this.buildUrl('/subscriptions/performer/search', query));
  }

  performerSearchUrl() {
    return '/subscriptions/performer/search';
  }

  userSearch(query?: { [key: string]: any }) {
    return this.get(this.buildUrl('/subscriptions/user/search', query));
  }

  userSearchEndpoint() {
    return '/subscriptions/user/search';
  }

  cancelSubscription(id: string, gateway: string) {
    return this.post(`/payment/${gateway}/cancel-subscription/${id}`);
  }

  subscribeFree(performerId: string) {
    return this.post('/subscriptions/subscribe-free', { performerId });
  }
}
export const subscriptionService = new SubscriptionService();
